// Closes the sidebar offcanvas when a link inside it is clicked
import { isHTMLElement } from "~/types/types.util"
import * as bootstrap from "bootstrap"

(() => {
  // Attach to a static parent (document or container)
  document.addEventListener("click", function (e) {
    const target = e.target

    if (
      target
      && isHTMLElement(target)
      && target.closest("#sidebar_content a:not([role='button']):not([data-turbo-stream])")
      && !target.closest("#sidebar_content button")
    ) {
      const sidebarOffcanvas = document.getElementById("sidebar_content")
      if (!sidebarOffcanvas) return

      const offcanvasInstance = bootstrap.Offcanvas.getInstance(sidebarOffcanvas)
      if (offcanvasInstance) offcanvasInstance.hide()
    }
  })
})()
